/* tslint:disable */
/* eslint-disable */
/**
 * GLC.Portal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ProductOptionViewModel } from './ProductOptionViewModel';
import {
    ProductOptionViewModelFromJSON,
    ProductOptionViewModelFromJSONTyped,
    ProductOptionViewModelToJSON,
} from './ProductOptionViewModel';
import type { ResultStates } from './ResultStates';
import {
    ResultStatesFromJSON,
    ResultStatesFromJSONTyped,
    ResultStatesToJSON,
} from './ResultStates';

/**
 * 
 * @export
 * @interface ResultOfListOfProductOptionViewModel
 */
export interface ResultOfListOfProductOptionViewModel {
    /**
     * 
     * @type {ResultStates}
     * @memberof ResultOfListOfProductOptionViewModel
     */
    resultState: ResultStates;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfProductOptionViewModel
     */
    type?: string;
    /**
     * 
     * @type {number}
     * @memberof ResultOfListOfProductOptionViewModel
     */
    status?: number;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfProductOptionViewModel
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof ResultOfListOfProductOptionViewModel
     */
    detail?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ResultOfListOfProductOptionViewModel
     */
    errors: Array<string>;
    /**
     * 
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ResultOfListOfProductOptionViewModel
     */
    validationErrors: { [key: string]: Array<string>; };
    /**
     * 
     * @type {Array<ProductOptionViewModel>}
     * @memberof ResultOfListOfProductOptionViewModel
     */
    data?: Array<ProductOptionViewModel>;
    /**
     * 
     * @type {number}
     * @memberof ResultOfListOfProductOptionViewModel
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfListOfProductOptionViewModel interface.
 */
export function instanceOfResultOfListOfProductOptionViewModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "resultState" in value;
    isInstance = isInstance && "errors" in value;
    isInstance = isInstance && "validationErrors" in value;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfListOfProductOptionViewModelFromJSON(json: any): ResultOfListOfProductOptionViewModel {
    return ResultOfListOfProductOptionViewModelFromJSONTyped(json, false);
}

export function ResultOfListOfProductOptionViewModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfListOfProductOptionViewModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'resultState': ResultStatesFromJSON(json['ResultState']),
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'detail': !exists(json, 'Detail') ? undefined : json['Detail'],
        'errors': json['Errors'],
        'validationErrors': json['ValidationErrors'],
        'data': !exists(json, 'Data') ? undefined : ((json['Data'] as Array<any>).map(ProductOptionViewModelFromJSON)),
        'count': json['Count'],
    };
}

export function ResultOfListOfProductOptionViewModelToJSON(value?: ResultOfListOfProductOptionViewModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ResultState': ResultStatesToJSON(value.resultState),
        'Type': value.type,
        'Status': value.status,
        'Title': value.title,
        'Detail': value.detail,
        'Errors': value.errors,
        'ValidationErrors': value.validationErrors,
        'Data': value.data === undefined ? undefined : ((value.data as Array<any>).map(ProductOptionViewModelToJSON)),
        'Count': value.count,
    };
}

